import { Modal } from '@chikara/ui';
import { formatCurrency } from '@chikara/utils';
import { t } from '@/i18n';
import type { LinkedAccount } from '../../types/credits.types';
import styles from './MakePaymentModal.module.css';

export interface MakePaymentModalProps {
  isOpen: boolean;
  onClose: () => void;
  amount: number;
  linkedAccount?: LinkedAccount | null;
  onConfirm: () => void;
  isConfirming?: boolean;
  supportEmail?: string;
}

export function MakePaymentModal({
  isOpen,
  onClose,
  amount,
  linkedAccount,
  onConfirm,
  isConfirming = false,
  supportEmail = 'ayuda@delt.ai',
}: MakePaymentModalProps) {
  const formatMXN = (value: number) =>
    formatCurrency(value, { locale: 'es-MX', currency: 'MXN' });

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={t('credits.makePaymentModal.title')}
      actionLabel={t('credits.makePaymentModal.payAction')}
      onAction={onConfirm}
      showCloseButton
      closeOnOverlayClick
      closeOnEsc
      isActionLoading={isConfirming}
      contentSize="lg"
      titleClassName={styles.modalTitle}
    >
      <div className={styles.body}>
        <div className={styles.amountSection}>
          <span className={styles.amountLabel}>
            {t('credits.makePaymentModal.amountLabel')}
          </span>
          <span className={styles.amountValue}>{formatMXN(amount)}</span>
        </div>

        <p className={styles.chargeIntro}>
          {t('credits.makePaymentModal.chargeIntro')}
        </p>

        {linkedAccount && (
          <div className={styles.accountCard}>
            <div className={styles.accountRow}>
              <span className={styles.cardLabel}>
                {t('credits.makePaymentModal.accountLabel')}
              </span>
              <span className={styles.cardValue}>{linkedAccount.accountName}</span>
            </div>
            <div className={styles.accountRowPair}>
              <div className={styles.accountRow}>
                <span className={styles.cardLabel}>
                  {t('credits.makePaymentModal.clabeLabel')}
                </span>
                <span className={styles.cardValue}>{linkedAccount.clabe}</span>
              </div>
              <div className={styles.accountRow}>
                <span className={styles.cardLabel}>
                  {t('credits.makePaymentModal.bankLabel')}
                </span>
                <span className={styles.cardValue}>{linkedAccount.bankName}</span>
              </div>
            </div>
          </div>
        )}

        <p className={styles.reminder}>
          {t('credits.makePaymentModal.reminder')}
        </p>
      </div>

      <p className={styles.footerHelp}>
        {t('credits.linkedAccountHelp')}
        <a
          href={`mailto:${supportEmail}`}
          className={styles.supportLink}
          rel="noopener noreferrer"
        >
          {supportEmail}
        </a>
      </p>
    </Modal>
  );
}

MakePaymentModal.displayName = 'MakePaymentModal';
